import { useSelector, useDispatch } from 'react-redux';
import {signinUser, signoutUser, setUserAuth} from "../../store/auth";

export default function useAuth() {
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    let signin = (data) => {
        dispatch(signinUser(data))
    }

    let signout = () => {
        dispatch(signoutUser())
    }

    let setAuth = (data) => {
        dispatch(setUserAuth(data))
    }

    let setUser = () => {
        dispatch();
    }

    return {user: auth.user, access_token: auth.access_token, auth, signin, signout, setAuth, setUser};
}
